import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';
import Switch from '@deliveroo/consumer-component-library/components/Switch';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';

import styles from './styles.scss';

export default class WhatsappModalContent extends Component {
  render() {
    const { optedIn, onSwitchChange } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.image} />
        <Heading level={4}>Want notifying when your rider&#39;s on the way?</Heading>
        <P color="grey">
          We&#39;ll let you know on WhatsApp when your rider&#39;s picked up your order
        </P>
        <Spacer spacing="large 0">
          <div className={styles['switch-wrapper']}>
            <Switch
              id="opt_in"
              onChange={onSwitchChange}
              name="whatsappOptIn"
              value="one"
              isOn={optedIn}
            />
            <div className={styles.label}>
              <P>Notify me</P>
            </div>
          </div>
          <div className={styles['text-left']}>
            <P size="x-small" color="grey">
              We&#39;ll send the message to the phone number associated with your delivery address.
              To opt out from WhatsApp notifications, just reply STOP.
            </P>
          </div>
        </Spacer>
      </div>
    );
  }
}

WhatsappModalContent.propTypes = {
  /** Whether the switch is on */
  optedIn: PropTypes.bool,
  /** Function called when switch is toggled */
  onSwitchChange: PropTypes.func.isRequired,
};

WhatsappModalContent.defaultProps = {
  optedIn: false,
};
